import { render, staticRenderFns } from "./categoryCreateOrUpdate.vue?vue&type=template&id=16a63eb0&scoped=true"
import script from "./categoryCreateOrUpdate.vue?vue&type=script&lang=js"
export * from "./categoryCreateOrUpdate.vue?vue&type=script&lang=js"
import style0 from "./categoryCreateOrUpdate.vue?vue&type=style&index=0&id=16a63eb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a63eb0",
  null
  
)

export default component.exports